export default class FolderPathController {
    /** @ngInject */
    constructor(EventEmitter, DialogService, FolderService, CharsService) {
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
        this.FolderService = FolderService;
        this.CharsService = CharsService;
    }

    $onInit() {
        this.folderPathPlaceholder = '';
        this.chars = this.CharsService.getList();
        this.folderSeparator = ' › ';
        this.maxChars = Infinity;
        this.ratio = 1;
        this.initFlag = true;

        if (this.folderPath.length) {
            this.update();
        }
    }

    $onChanges(changes) {
        if (changes.emptyTrail) {
            this.emptyTrail = changes.emptyTrail.currentValue;
        }
        if (changes.folderId) {
            this.folderId = changes.folderId.currentValue;
        }
        if (this.folderId) {
            this.folderPath = this.FolderService.buildFolderPath(this.folderId);
            if (this.emptyTrail) {
                this.folderPath.push({
                    name: ''
                });
            }
        } else {
            this.folderPath = [];
        }

        if (this.folderPath.length && this.initFlag) {
            this.update();
        }
    }

    update() {
        this.createStr();

        if (this.maxWidth) {
            this.calcMaxChars();
        }

        this.render();
    }

    createStr() {
        this.folderPathText = this.folderPath.reduce((sum, item, index) => {
            let part;

            if (index !== (this.folderPath.length - 1)) {
                part = `${sum + item.name} › `;
            } else {
                part = sum + item.name;
            }

            return part;
        }, '');
    }

    calcMaxChars() {
        this.calcRation();

        this.maxChars = 0;

        let maxWidth = this.maxWidth - (16 * this.ratio);

        for (let i = 0; i < this.folderPathText.length; i++) {
            let charWidth;

            try {
                charWidth = this.chars[this.folderPathText.charAt(i)].width * this.ratio;
            } catch (error) {
                charWidth = 10 * this.ratio;
            }

            if (maxWidth - charWidth > 0) {
                maxWidth -= charWidth;
                this.maxChars += 1;
            } else {
                break;
            }
        }
    }

    render() {
        if (this.folderPathText.length > this.maxChars) {
            if (this.folderPath.length < 2) {
                this.folderPathPlaceholder = `${this.folderPathText.slice(0, this.maxChars)}...`;
            } else {
                const temp = this.folderPathText.slice(-this.maxChars).split(this.folderSeparator);
                temp.shift();

                if (temp.length > 1) {
                    this.folderPathPlaceholder = `...${this.folderSeparator}
                        ${temp.filter(item => item.length).map(item => item.trim()).join(this.folderSeparator)}`;
                } else {
                    const placeholder = `...${this.folderSeparator}${this.folderPath.pop().name}`;

                    if (placeholder.length > this.maxChars) {
                        this.folderPathPlaceholder = `${placeholder.slice(0, this.maxChars)}...`;
                    } else {
                        this.folderPathPlaceholder = placeholder;
                    }
                }
            }
            this.folderPathFull = this.folderPathText;
        } else {
            this.folderPathPlaceholder = this.folderPathText;
            this.folderPathFull = null;
        }
    }

    calcRation() {
        this.ratio = window.devicePixelRatio;
        this.ratio *= !isNaN(parseInt(this.fontSize, 10)) ? (parseInt(this.fontSize, 10) / 10) : 1;
    }
}



// WEBPACK FOOTER //
// ./app/common/folder-path/folder-path.controller.js